// Berichtscenter (Objekt): Zeilen je Einheit mit dem aktuellen Mieter – Grundlage für
// Objektübersicht, Mietübersicht und Mietaufstellung (lib/export/mietberichte).

import { istWohnend } from '../dashboard/leerstand';
import type { MietRow } from '../export/mietberichte';

export interface BerichtEinheit { id: string; bezeichnung: string | null; typ?: string | null; wohnflaeche?: number | string | null; etage?: string | null; status?: string | null }
export interface BerichtMieter {
  id: string; einheit_id: string | null; einheit?: string | null; status: string | null; mietbeginn?: string | null;
  vorname?: string | null; nachname?: string | null; firma_name?: string | null;
  kaltmiete?: number | string | null; nebenkosten_vorauszahlung?: number | string | null; heizkosten?: number | string | null;
}
export type BerichtZeile = MietRow & { bezeichnung: string };

const zahlOderNull = (v: unknown): number | null => {
  if (v === null || v === undefined || v === '') return null;
  const n = Number(String(v).replace(',', '.'));
  return Number.isFinite(n) ? n : null;
};

/**
 * Je Einheit der aktuell wohnende Mieter (aktiv oder gekündigt, auch ohne Status – wie überall
 * im Immobilienbereich); bei mehreren der am längsten wohnende. Altbestand ohne objekt_einheiten:
 * Einheiten aus mieter.einheit ableiten (wie bisher).
 */
export function berichtZeilen(einheiten: readonly BerichtEinheit[], alleMieter: readonly BerichtMieter[]): BerichtZeile[] {
  // Beträge können als Text gespeichert sein – für die Berichte als Zahl
  const mieter = alleMieter.map(m => ({
    ...m, kaltmiete: zahlOderNull(m.kaltmiete), nebenkosten_vorauszahlung: zahlOderNull(m.nebenkosten_vorauszahlung), heizkosten: zahlOderNull(m.heizkosten),
  }));
  const wohnend = mieter.filter(m => istWohnend(m.status))
    .sort((a, b) => (a.mietbeginn ?? '9999').localeCompare(b.mietbeginn ?? '9999'));
  if (einheiten.length > 0) {
    return einheiten.map(e => {
      const bez = (e.bezeichnung ?? '').trim();
      const m = wohnend.find(x => (x.einheit_id ? x.einheit_id === e.id : !!bez && (x.einheit ?? '').trim() === bez)) ?? null;
      return { bezeichnung: bez || 'Ohne Bezeichnung', einheit: { ...e, wohnflaeche: zahlOderNull(e.wohnflaeche) }, mieter: m };
    });
  }
  const je = new Map<string, BerichtZeile>();
  for (const m of mieter) {
    const bez = (m.einheit ?? '').trim() || 'Unbekannt';
    const z = je.get(bez) ?? { bezeichnung: bez, einheit: null, mieter: null };
    if (!z.mieter && istWohnend(m.status)) z.mieter = m;
    je.set(bez, z);
  }
  return [...je.values()];
}
